// extracted by css-extract-rspack-plugin
export default {"cls1":"common-cls1_hRY","cls2":"common-cls2_YLs common-cls1_hRY","active":"common-active_S-D"};